export default __webpack_public_path__ + "static/media/annur-ayat-32.dae2a03f.mp3";